// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {
		$('.js-open-menu').click(function() {
		    $('.header').toggleClass('nav-open');
		    $('.book-footer').toggleClass('close-footer');
		    $('.burger').toggleClass('open');
		    $('.burger').fadeToggle();

			var $menuLink = $(this); 
			var currentText = $menuLink.find('span').text(); 
			
			if (currentText === 'MENU') {
				$menuLink.find('span').text('CLOSE');
			} else {
				$menuLink.find('span').text('MENU');
			}

		});
		$('.js-search, .close-search').click(function(e) {
			e.preventDefault();
			$('.search-bar').toggleClass('open');			
		});
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 200){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		if(document.getElementById('back') && !document.getElementById('back').classList.contains('show')){
			document.getElementById('back').classList.add('show');
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.getElementById('back') && document.getElementById('back').classList.contains('show')){
			document.getElementById('back').classList.remove('show');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}
